<div class="container-fluid d-flex p-0">
    <app-side-bar></app-side-bar>
    <ng-container>
        <div style="padding: 15px; margin: 5px;width: -webkit-fill-available;">
            <div class="main-heading">
                <h1>Litigation Complaints Dashboard</h1>
            </div>

            <button (click)="refreshData()" class="btn btn-primary" style="margin-bottom: 10px;">
                Refresh Data
            </button>

            <div class="card">
                <p-table #litigationdata [value]="filteredLitigationData" [(selection)]="selectedLitigationData"
                    [tableStyle]=" {'min-width': '60rem' }" [paginator]="true" [rows]="10"
                    [showCurrentPageReport]="true" paginatorPosition="both" [scrollable]="true"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    [rowsPerPageOptions]="[10, 50, 100]" [loading]="loading"
                    [globalFilterFields]="['Case Number', 'NDA Number', 'Brand Name', 'Plaintiff', 'Defendant', 'Filed ANDA', 'ANDA Number', 'Court Name', 'Judge', 'Field ID', 'PDF File']">
                    <ng-template pTemplate="caption">
                        <div class="flex" style="display: flex; justify-content: flex-end; gap: 10px;">
                            <p-dropdown [options]="dropdownOptions" [(ngModel)]="selectedOption"
                                (onChange)="onOptionChange($event)">
                            </p-dropdown>
                            <p-calendar [(ngModel)]="startdate" dateFormat="mm/dd/yy" [showIcon]="true"
                                placeholder="Start Date" (ngModelChange)="onOptionChange($event)">
                            </p-calendar>

                            <p-calendar [(ngModel)]="enddate" dateFormat="mm/dd/yy" [showIcon]="true"
                                placeholder="End Date" (ngModelChange)="onOptionChange($event)">
                            </p-calendar>

                            <button class="btn btn-primary" style="background-color: #2196F3;"
                                (click)="clearDates()">Clear</button>

                            <span class="p-input-icon-left ml-auto">
                                <input pInputText type="text"
                                    (input)="litigationdata.filterGlobal($event.target.value, 'contains')"
                                    placeholder="Search" />
                            </span>
                        </div>
                        <p *ngIf="dateError" style="color: red; margin-top: 5px;text-align: center;
">
                            {{ dateError }}
                        </p>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="Case Number">
                                <span class="header-container">
                                    Case Number
                                    <p-sortIcon field="Case Number"></p-sortIcon>
                                </span>
                            </th>
                            <th pSortableColumn="NDA Number">
                                <span class="header-container">
                                    NDA Number
                                    <p-sortIcon field="NDA Number"></p-sortIcon>
                                </span>
                            </th>
                            <th pSortableColumn="Brand Name">
                                <span class="header-container">
                                    Brand Name
                                    <p-sortIcon field="Brand Name"></p-sortIcon>
                                </span>
                            </th>
                            <th pSortableColumn="Plaintiff">
                                <span class="header-container">
                                    Plaintiffs
                                    <p-sortIcon field="Plaintiff"></p-sortIcon>
                                </span>
                            </th>
                            <th pSortableColumn="Defendant">
                                <span class="header-container">
                                    Defendants
                                    <p-sortIcon field="Defendant"></p-sortIcon>
                                </span>
                            </th>
                            <th pSortableColumn="Filed ANDA">
                                <span class="header-container">
                                    Filed ANDA
                                    <p-sortIcon field="Filed ANDA"></p-sortIcon>
                                </span>
                            </th>
                            <th pSortableColumn="ANDA Number">
                                <span class="header-container">
                                    ANDA Number
                                    <p-sortIcon field="ANDA Number"></p-sortIcon>
                                </span>
                            </th>
                            <th pSortableColumn="Court Name">
                                <span class="header-container">
                                    Court Name
                                    <p-sortIcon field="Court Name"></p-sortIcon>
                                </span>
                            </th>
                            <th pSortableColumn="Judge">
                                <span class="header-container">
                                    Judge Name
                                    <p-sortIcon field="Judge"></p-sortIcon>
                                </span>
                            </th>
                            <th pSortableColumn="Field ID">
                                <span class="header-container">
                                    Filed Date
                                    <p-sortIcon field="Field ID"></p-sortIcon>
                                </span>
                            </th>
                            <th pSortableColumn="PDF File">
                                <span class="header-container">
                                    PDF
                                    <p-sortIcon field="PDF File"></p-sortIcon>
                                </span>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData>
                        <tr>
                            <td>{{ rowData['Case Number'] }}</td>
                            <td>{{ rowData['NDA Number'] }}</td>
                            <td>{{ rowData['Brand Name'] }}</td>
                            <td>{{ rowData['Plaintiff'] }}</td>
                            <td>{{ rowData['Defendant'] }}</td>
                            <td>{{ rowData['Filed ANDA'] }}</td>
                            <td>{{ rowData['ANDA Number'] }}</td>
                            <td>{{ rowData['Court Name'] }}</td>
                            <td>{{ rowData['Judge'] }}</td>
                            <td>{{ rowData['Field ID'] }}</td>
                            <td>
                                <a (click)="openPdf(rowData['PDF File'])" style="color: #007bff; cursor: pointer;"
                                    *ngIf="rowData['PDF File'] != 'N/A'; else noPdf">View PDF</a>
                                <ng-template #noPdf>N/A</ng-template>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </ng-container>
</div>